/**
 * Utility function to scroll to the selected value in a react-select dropdown
 * @param selectedOption - The currently selected option with label and value
 * @param delay - Optional delay in milliseconds (default: 150ms)
 */
export const scrollToSelectedValue = (
  selectedOption: { label: string; value: any } | null,
  delay = 150
) => {
  if (!selectedOption) return;

  // Use setTimeout to ensure the menu is fully rendered
  setTimeout(() => {
    // Find the menu element
    const menuElement = document.querySelector('.react-select__menu');
    if (menuElement) {
      // Find all option elements
      const optionElements = menuElement.querySelectorAll('.react-select__option');
      
      const targetElement = Array.from(optionElements).find((option) => {
        // Check if this option contains the selected value text
        const optionText = option.textContent;
        return optionText?.includes(selectedOption.label);
      });
      
      if (targetElement) {
        (targetElement as HTMLElement).scrollIntoView({ 
          block: 'center',
          behavior: 'smooth'
        });
      }
    }
  }, delay);
}; 